import Login from "../Components/Common/Login/Login";
import Dashboard from "../Components/Dashboard/Dashboard";
import Profile from "../Components/Dashboard/Profile/Profile";
import Inicio from "../Components/Inicio/Inicio"
import Demandas from "../Components/Demandas/Demandas"
import Acreditados from "../Components/Acreditados/Acreditados"
import AcreditadosDetalle from "../Components/AcreditadosDetalle/AcreditadosDetalle"
import InformacionAcreditados from "../Components/Acreditados/InformacionAcreditados/InformacionAcreditados";
import MiPerfil from "../Components/MiPerfil/MiPerfil";
import MiActividad from "../Components/MiActividad/MiActividad";
import CentroImpresion from "../Components/CentroImpresion/CentroImpresion";
import RelacionAcreditados from "../Components/RelacionAcreditados/RelacionAcreditados";
import GestionesMasivas from "../Components/GestionesMasivas/GestionesMasivas"

const routes = [
  {
    path: "/login",
    component: Login,
    isPrivate: false,
    isExact: true,
  },
  {
    path: "/Dashboard",
    component: Dashboard,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/MiPerfil",
    component: MiPerfil,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/MiActividad",
    component: MiActividad,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/CentroImpresion/:reporte",
    component: CentroImpresion,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/RelacionAcreditados",
    component: RelacionAcreditados,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/Inicio",
    component: Inicio,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/Acreditados",
    component: Acreditados,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/Demandas",
    component: Demandas,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/Demandas",
    component: Demandas,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/AcreditadosDetalle/:id",
    component: AcreditadosDetalle,
    isPrivate: true,
    isExact: true,
  },
  {
    path: "/InformacionAcreditados/:id",
    component: InformacionAcreditados,
    isPrivate: true,
    isExact: true,
  },
  {
    path:"/GestionesMasivas",
    component: GestionesMasivas,
    isPrivate: true,
    isExact: true,
  }

];

export default routes;
